// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"803":"4982a18f","863":"72f020f9"}[chunkId] + ".chunk.js";
};